<template>
  <div>
    <Movementmenu />

    <v-container fluid class="pa-6" tag="section">
      <v-row class="mb-2">
        <v-col cols="12">
          <h2 class="text-h4 font-weight-bold mb-2 primary--text">
            <v-icon large color="primary" class="mr-2"
              >mdi-account-search</v-icon
            >
            วิเคราะห์และจัดกลุ่มผู้ประสงค์ขอย้าย
          </h2>
          <div class="subtitle-1 grey--text text--darken-1">
            จัดกลุ่มตามสถานศึกษาเป้าหมาย และวิเคราะห์ความน่าจะเป็นประจำรอบ
            {{ times_select }}/{{ years_select }}
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            style="border-left: 5px solid #1976D2"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">รายการขอย้ายทั้งหมด</div>
                <div class="text-h4 font-weight-bold">{{ stats.total }}</div>
              </div>
              <v-avatar color="blue lighten-5" size="60">
                <v-icon color="blue" x-large>mdi-account-group</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            style="border-left: 5px solid #4CAF50"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">เอกสารสมบูรณ์</div>
                <div class="text-h4 font-weight-bold success--text">
                  {{ stats.docComplete }}
                </div>
              </div>
              <v-avatar color="green lighten-5" size="60">
                <v-icon color="success" x-large>mdi-file-check</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            style="border-left: 5px solid #9C27B0"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">ผอ. เห็นควร</div>
                <div class="text-h4 font-weight-bold purple--text">
                  {{ stats.directorApprove }}
                </div>
              </div>
              <v-avatar color="purple lighten-5" size="60">
                <v-icon color="purple" x-large>mdi-thumb-up</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            style="border-left: 5px solid #FF5252"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">
                  ติดเงื่อนไข / ช่วยราชการ
                </div>
                <div class="text-h4 font-weight-bold red--text">
                  {{ stats.hasCondition }}
                </div>
              </div>
              <v-avatar color="red lighten-5" size="60">
                <v-icon color="red" x-large>mdi-alert-octagon</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-card elevation="2" class="rounded-lg mb-4">
        <v-toolbar flat color="white" class="pt-2">
          <v-row align="center">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหา ชื่อ, สาขาวิชา, วิทยาลัย..."
                single-line
                hide-details
                outlined
                dense
                rounded
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-switch
                v-model="isGrouped"
                label="จัดกลุ่มตามวิทยาลัยปลายทาง"
                color="primary"
                hide-details
                class="mt-0"
              ></v-switch>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn color="primary" block rounded depressed @click="fetchData">
                <v-icon left>mdi-refresh</v-icon> โหลดข้อมูลใหม่
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                color="success"
                outlined
                block
                rounded
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> Export Excel
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
      </v-card>

      <v-card elevation="2" class="rounded-lg">
        <v-data-table
          :headers="headers"
          :items="analyzedTransfers"
          :search="search"
          :loading="loading"
          :group-by="isGrouped ? 'college_name' : null"
          class="elevation-0 table-striped"
          :items-per-page="50"
        >
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th :colspan="headers.length" class="bg-light-blue lighten-5 py-3">
              <div class="d-flex align-center cursor-pointer" @click="toggle">
                <v-icon color="primary" class="mr-3">
                  {{ isOpen ? "mdi-chevron-down" : "mdi-chevron-right" }}
                </v-icon>
                <v-icon color="primary" class="mr-2">mdi-school</v-icon>
                <span class="text-h6 primary--text font-weight-bold">{{
                  items[0].college_name
                }}</span>
                <v-spacer></v-spacer>
                <v-chip color="primary" outlined small class="mr-2 bg-white">
                  ผู้ขอย้าย: {{ items.length }} ราย
                </v-chip>
              </div>
            </th>
          </template>

          <template v-slot:item.tlsequence_n="{ item }">
            <div class="text-center font-weight-bold">
              {{ item.tlsequence_n }}
            </div>
          </template>

          <template v-slot:item.college_name="{ item }">
            <div class="font-weight-bold primary--text">
              <v-icon small color="primary" class="mr-1">mdi-school</v-icon>
              {{ item.college_name }}
            </div>
            <div class="caption grey--text text--darken-1">
              ตำแหน่งว่าง: {{ item.id_man_power || "-" }}
            </div>
          </template>

          <template v-slot:item.personnel_name="{ item }">
            <div
              class="font-weight-bold d-flex align-center"
              :class="{ 'warning--text': item.is_likely }"
            >
              {{ item.personnel_name }}
              <v-tooltip bottom v-if="item.is_likely">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="warning"
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                    large
                    >mdi-star-circle</v-icon
                  >
                </template>
                <span
                  >คาดว่าได้ย้าย (คะแนนถึงเกณฑ์และมีตำแหน่งว่างเพียงพอ)</span
                >
              </v-tooltip>
            </div>
            <div class="caption grey--text text--darken-2">
              เดิม: {{ item.college_name_now }} ({{ item.id_position_now }})
            </div>
          </template>

          <template v-slot:item.branch_info="{ item }">
            <v-chip
              small
              color="blue-grey lighten-4"
              text-color="blue-grey darken-4"
              class="mb-1"
            >
              {{ item.id_branch }} : {{ item.name_branch }}
            </v-chip>
            <div class="caption primary--text mt-1" v-if="isGrouped">
              <strong>ว่าง {{ item.available_positions }} อัตรา</strong>
              <span class="grey--text"
                >(เลขที่: {{ item.id_man_power || "-" }})</span
              >
            </div>
          </template>

          <template v-slot:item.total_s="{ item }">
            <v-tooltip
              top
              v-if="item.total_s !== null && item.total_s !== undefined"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  :color="rateDiffColor(item.total_s)"
                  dark
                  x-small
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.total_s > 0 ? "+" : "" }}{{ item.total_s }}
                </v-chip>
              </template>
              <span>
                อัตรากำลังสถานศึกษาต้นทาง ({{ item.college_name_now }}):
                {{ item.total_s_origin_status || "-" }}
                {{ item.total_s > 0 ? "+" : "" }}{{ item.total_s }} คน
              </span>
            </v-tooltip>
            <span v-else class="grey--text">-</span>
          </template>

          <template v-slot:item.total_s_news="{ item }">
            <v-tooltip
              top
              v-if="item.total_s_news !== null && item.total_s_news !== undefined"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  :color="rateDiffColor(item.total_s_news)"
                  dark
                  x-small
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.total_s_news > 0 ? "+" : "" }}{{ item.total_s_news }}
                </v-chip>
              </template>
              <span>
                อัตรากำลังสถานศึกษาปลายทาง ({{ item.college_name }}):
                {{ item.total_s_news_status || "-" }}
                {{ item.total_s_news > 0 ? "+" : "" }}{{ item.total_s_news }} คน
              </span>
            </v-tooltip>
            <span v-else class="grey--text">-</span>
          </template>

          <template v-slot:item.status_document="{ item }">
            <v-chip
              :color="getDocStatusColor(item.status_document)"
              dark
              x-small
              label
            >
              {{ getDocStatusText(item.status_document) }}
            </v-chip>
          </template>

          <template v-slot:item.comment_dr_c="{ item }">
            <v-chip :color="getCommentColor(item.comment_dr_c)" dark x-small>
              {{ getCommentText(item.comment_dr_c) }}
            </v-chip>
          </template>

          <template v-slot:item.total_score="{ item }">
            <v-chip
              :color="item.is_likely ? 'warning' : 'grey lighten-3'"
              :text-color="item.is_likely ? 'white' : 'black'"
              class="font-weight-bold px-3"
              style="font-size: 16px;"
            >
              {{ item.total_score }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="info"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDetail(item)"
                >
                  <v-icon>mdi-text-box-search-outline</v-icon>
                </v-btn>
              </template>
              <span>ดูข้อมูลฉบับเต็ม</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialogDetail" max-width="900px">
        <v-card v-if="selectedItem" class="rounded-lg">
          <v-toolbar color="primary" dark flat>
            <v-icon class="mr-2">mdi-account-details</v-icon>
            รายละเอียดการขอย้าย
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogDetail = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-4">
            <v-alert
              v-if="selectedItem.is_likely"
              type="warning"
              dense
              text
              class="mb-4 font-weight-bold"
            >
              บุคลากรท่านนี้มีโอกาสได้รับการอนุมัติย้าย
              (คะแนนถึงเกณฑ์และมีตำแหน่งว่างรองรับ)
            </v-alert>

            <v-row>
              <v-col cols="12" md="6">
                <div class="text-overline primary--text">
                  ข้อมูลผู้ยื่นความจำนง
                </div>
                <v-simple-table dense class="mb-4">
                  <tbody>
                    <tr>
                      <th class="text-left" width="40%">ชื่อ-สกุล:</th>
                      <td>{{ selectedItem.personnel_name }}</td>
                    </tr>
                    <tr>
                      <th class="text-left">สถานศึกษาเดิม:</th>
                      <td>{{ selectedItem.college_name_now }}</td>
                    </tr>
                    <tr>
                      <th class="text-left">เลขที่ตำแหน่งเดิม:</th>
                      <td>{{ selectedItem.id_position_now }}</td>
                    </tr>
                    <tr>
                      <th class="text-left">อายุราชการสะสม:</th>
                      <td>{{ selectedItem.age_time }}</td>
                    </tr>
                    <tr>
                      <th class="text-left">อายุราชการที่ปัจจุบัน:</th>
                      <td>{{ selectedItem.age_app_time }}</td>
                    </tr>
                    <tr>
                      <th class="text-left">อัตรากำลังที่เดิม:</th>
                      <td>
                        {{ selectedItem.total_s }} ({{
                          selectedItem.total_s_origin_status || "-"
                        }})
                      </td>
                    </tr>
                    <tr>
                      <th class="text-left">การช่วยราชการ:</th>
                      <td
                        :class="
                          selectedItem.service_status === 'service'
                            ? 'red--text font-weight-bold'
                            : ''
                        "
                      >
                        {{
                          selectedItem.service_status === "service"
                            ? "กำลังช่วยราชการ"
                            : "ปกติ"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col cols="12" md="6">
                <div class="text-overline success--text">
                  ข้อมูลสถานศึกษาปลายทาง
                </div>
                <v-simple-table dense>
                  <tbody>
                    <tr>
                      <th class="text-left" width="40%">สถานศึกษาเป้าหมาย:</th>
                      <td>{{ selectedItem.college_name }}</td>
                    </tr>
                    <tr>
                      <th class="text-left">สาขาวิชา:</th>
                      <td>
                        {{ selectedItem.id_branch }} :
                        {{ selectedItem.name_branch }}
                      </td>
                    </tr>
                    <tr>
                      <th class="text-left">ลำดับที่ขอย้าย:</th>
                      <td>ที่ {{ selectedItem.tlsequence_n }}</td>
                    </tr>
                    <tr>
                      <th class="text-left">จำนวนรับ:</th>
                      <td>{{ selectedItem.available_positions }} อัตรา</td>
                    </tr>
                    <tr>
                      <th class="text-left">เลขที่ตำแหน่งว่าง:</th>
                      <td>{{ selectedItem.id_man_power || "-" }}</td>
                    </tr>
                    <tr>
                      <th class="text-left">อัตรากำลังปลายทาง:</th>
                      <td>
                        {{ selectedItem.total_s_news }} ({{
                          selectedItem.total_s_news_status || "-"
                        }})
                      </td>
                    </tr>
                    <tr>
                      <th class="text-left">เหตุผลการขอย้าย:</th>
                      <td class="font-weight-bold">
                        {{ selectedItem.reason || "-" }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col cols="12">
                <v-divider class="mb-3"></v-divider>
                <div class="text-overline warning--text">
                  ความเห็นและผลคะแนน
                </div>
                <v-row>
                  <v-col cols="4">
                    <strong>ความเห็น ผอ. ต้นสังกัด:</strong><br />
                    <v-chip
                      :color="getCommentColor(selectedItem.comment_dr_c)"
                      dark
                      small
                      class="mt-1"
                    >
                      {{ getCommentText(selectedItem.comment_dr_c) }}
                    </v-chip>
                  </v-col>
                  <v-col cols="4">
                    <strong>สถานะเอกสาร:</strong><br />
                    <v-chip
                      :color="getDocStatusColor(selectedItem.status_document)"
                      dark
                      small
                      class="mt-1"
                    >
                      {{ getDocStatusText(selectedItem.status_document) }}
                    </v-chip>
                  </v-col>
                  <v-col cols="4">
                    <strong>คะแนนรวม (สอจ. + กก.):</strong><br />
                    <span
                      class="text-h5 font-weight-bold"
                      :class="
                        selectedItem.is_likely
                          ? 'warning--text'
                          : 'primary--text'
                      "
                    >
                      {{ selectedItem.total_score }} คะแนน
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-btn color="grey darken-2" text @click="dialogDetail = false"
              >ปิดหน้าต่าง</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
// ตรวจสอบที่อยู่ของ Component ของอาจารย์อีกครั้ง ถ้าไม่ตรงให้เปลี่ยน path ครับ
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "PendingTransfersGroupedFull",
  components: { Movementmenu },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      search: "",

      // ตัวแปรสำหรับคัดกรองข้อมูล (สมมติว่าเชื่อมกับระบบ หรือระบุค่า Default)
      times_select: "1",
      years_select: "2566",
      type_select: "teach", // "teach" หรือ "admin"

      process_transfers: [], // ข้อมูลดิบจาก API

      // สวิตช์สำหรับ เปิด/ปิด การจัดกลุ่มในตาราง
      isGrouped: true,

      dialogDetail: false,
      selectedItem: null
    };
  },

  computed: {
    // กำหนดคอลัมน์ของ Data Table แบบไดนามิก (ซ่อนคอลัมน์ 'วิทยาลัย' ถ้ายกจัดกลุ่มแล้ว)
    headers() {
      let baseHeaders = [
        {
          text: "ลำดับที่",
          value: "tlsequence_n",
          align: "center",
          width: "80px"
        }
      ];

      if (!this.isGrouped) {
        baseHeaders.push({
          text: "วิทยาลัยปลายทาง (เป้าหมาย)",
          value: "college_name",
          align: "left"
        });
      }

      baseHeaders.push(
        {
          text: "ชื่อ-สกุล (ผู้ขอย้าย)",
          value: "personnel_name",
          align: "left"
        },
        { text: "สาขาวิชา", value: "branch_info", align: "left" },
        {
          text: "อัตรากำลังต้นทาง",
          value: "total_s",
          align: "center",
          width: "120px"
        },
        {
          text: "อัตรากำลังปลายทาง",
          value: "total_s_news",
          align: "center",
          width: "120px"
        },
        {
          text: "เอกสาร",
          value: "status_document",
          align: "center",
          width: "100px"
        },
        {
          text: "ความเห็น ผอ.",
          value: "comment_dr_c",
          align: "center",
          width: "100px"
        },
        {
          text: "คะแนนรวม",
          value: "total_score",
          align: "center",
          width: "100px"
        },
        {
          text: "จัดการ",
          value: "actions",
          align: "center",
          sortable: false,
          width: "80px"
        }
      );

      return baseHeaders;
    },

    // คำนวณสรุปข้อมูลสำหรับ Card ด้านบน
    stats() {
      const total = this.process_transfers.length;
      const docComplete = this.process_transfers.filter(
        i => i.status_document === "complete"
      ).length;
      const directorApprove = this.process_transfers.filter(
        i => i.comment_dr_c === "approp"
      ).length;
      const hasCondition = this.process_transfers.filter(
        i => i.service_status === "service" || i.comment_dr_c === "suspend"
      ).length;
      return { total, docComplete, directorApprove, hasCondition };
    },

    // คำนวณความน่าจะเป็น (ใครมีโอกาสได้ย้ายบ้าง) และจัดเตรียมข้อมูลให้ตาราง
    analyzedTransfers() {
      if (!this.process_transfers || this.process_transfers.length === 0)
        return [];

      // 1. Map ข้อมูลและคำนวณคะแนนเบื้องต้น
      let data = this.process_transfers.map(item => {
        let score =
          parseInt(item.tpvecprovince_score || 0) +
          parseInt(item.score_1420 || 0);

        // นับตำแหน่งว่างจากช่องว่าง (space) ใน id_man_power
        let positionsCount = 0;
        if (item.id_man_power && item.id_man_power.trim() !== "") {
          positionsCount = item.id_man_power.trim().split(/\s+/).length;
        }

        return {
          ...item,
          total_score: score,
          available_positions: positionsCount,
          is_likely: false
        };
      });

      // 2. จัดกลุ่มตาม "วิทยาลัยปลายทาง" และ "สาขาวิชา"
      let groupedByCollegeAndBranch = {};
      data.forEach(item => {
        let key = `${item.college_code_susss || item.college_name}_${
          item.id_branch
        }`;
        if (!groupedByCollegeAndBranch[key]) {
          groupedByCollegeAndBranch[key] = [];
        }
        groupedByCollegeAndBranch[key].push(item);
      });

      // 3. วิเคราะห์โควต้าในแต่ละกลุ่ม (แจกมงกุฎ/ดาว ให้คนที่ได้คะแนนสูงสุด)
      for (let key in groupedByCollegeAndBranch) {
        let group = groupedByCollegeAndBranch[key];
        let maxPositions = group[0].available_positions;

        if (maxPositions > 0) {
          // กรองคนที่เอกสารครบ และ ผอ.เห็นควร (สามารถเพิ่มเงื่อนไขอื่นๆ ได้ที่นี่)
          let eligibleCandidates = group.filter(
            g => g.comment_dr_c === "approp" && g.status_document === "complete"
          );

          // เรียงตามคะแนนรวม (จากมากไปน้อย)
          // *ถ้าระเบียบมีการดู ลำดับขอย้าย หรือ อายุราชการ สามารถเพิ่มเงื่อนไข sort ได้เลย
          eligibleCandidates.sort((a, b) => b.total_score - a.total_score);

          // มอบสถานะ "มีโอกาส (is_likely = true)" ให้ตามจำนวนตำแหน่งที่ว่าง
          for (
            let i = 0;
            i < Math.min(eligibleCandidates.length, maxPositions);
            i++
          ) {
            let originalItem = data.find(
              d => d.id_ref === eligibleCandidates[i].id_ref
            );
            if (originalItem) {
              originalItem.is_likely = true;
            }
          }
        }
      }

      // 4. จัดเรียงข้อมูลเพื่อแสดงผล (เอาคนที่มีโอกาสขึ้นก่อนในกลุ่มเดียวกัน)
      return data.sort((a, b) =>
        a.is_likely === b.is_likely ? 0 : a.is_likely ? -1 : 1
      );
    }
  },

  mounted() {
    // โหลดข้อมูลเมื่อเปิดหน้าจอ
    this.fetchData();
  },

  methods: {
    // เรียกข้อมูลจาก API PHP
    async fetchData() {
      this.loading = true;
      try {
        let payload = {
          ApiKey: this.ApiKey,
          time_s: this.times_select,
          year_s: this.years_select,
          name_position: this.type_select === "teach" ? "ครู" : "บริหาร"
        };
        // เรียกใช้ process_transfer.php
        let result = await this.$http.post("process_transfer.php", payload);
        this.process_transfers = result.data || [];
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },

    // เปิดหน้าต่างดูรายละเอียด
    openDetail(item) {
      this.selectedItem = item;
      this.dialogDetail = true;
    },

    // สีของ chip อัตรากำลังขาด/เกินเกณฑ์ (แดง=ขาด, ส้ม=เกิน, เขียว=พอดี)
    rateDiffColor(diff) {
      const d = parseInt(diff) || 0;
      if (d < 0) return "red";
      if (d > 0) return "orange";
      return "success";
    },

    // แปลงสถานะเอกสารเป็นข้อความ
    getDocStatusText(status) {
      if (status === "complete") return "สมบูรณ์";
      if (status === "incomplete") return "ไม่สมบูรณ์";
      if (status === "do_not") return "ไม่จัดส่ง";
      return "รอดำเนินการ";
    },

    // แปลงสถานะเอกสารเป็นสี
    getDocStatusColor(status) {
      if (status === "complete") return "green";
      if (status === "incomplete") return "orange";
      if (status === "do_not") return "red";
      return "grey";
    },

    // แปลงความเห็น ผอ. เป็นข้อความ
    getCommentText(comment) {
      if (comment === "approp") return "เห็นควร";
      if (comment === "inapprop") return "ไม่เห็นควร";
      if (comment === "suspend") return "ระงับย้าย";
      return "รอพิจารณา";
    },

    // แปลงความเห็น ผอ. เป็นสี
    getCommentColor(comment) {
      if (comment === "approp") return "success";
      if (comment === "inapprop") return "warning";
      if (comment === "suspend") return "red";
      return "grey";
    },

    // ฟังก์ชัน Export Excel (ดาวน์โหลดออกเป็นไฟล์ .xlsx)
    exportToExcel() {
      // นำข้อมูลที่ผ่านการวิเคราะห์ (analyzedTransfers) มาออก Report เพื่อให้ตรงกับที่โชว์บนจอ
      const exportData = this.analyzedTransfers.map((item, index) => ({
        ที่: index + 1,
        วิทยาลัยเป้าหมาย: item.college_name,
        "จำนวนรับ (อัตรา)": item.available_positions,
        ตำแหน่งว่างปลายทาง: item.id_man_power || "-",
        "ชื่อ-นามสกุล": item.personnel_name,
        ตำแหน่งเดิม: item.id_position_now,
        สังกัดเดิม: item.college_name_now,
        สาขาวิชา: `${item.id_branch} : ${item.name_branch}`,
        "อัตรากำลังต้นทาง (สถานะ)": item.total_s_origin_status || "",
        "อัตรากำลังต้นทาง (ผลต่าง)": item.total_s,
        "อัตรากำลังปลายทาง (สถานะ)": item.total_s_news_status || "",
        "อัตรากำลังปลายทาง (ผลต่าง)": item.total_s_news,
        ลำดับขอย้าย: item.tlsequence_n,
        อายุราชการสะสม: item.age_time,
        เหตุผลการย้าย: item.reason,
        "ความเห็น ผอ.": this.getCommentText(item.comment_dr_c),
        สถานะเอกสาร: this.getDocStatusText(item.status_document),
        คะแนนรวม: item.total_score,
        แนวโน้มได้ย้าย: item.is_likely ? "มีโอกาส" : "รองเกณฑ์"
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Pending_Transfers");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      });
      saveAs(
        data,
        `Pending_Transfers_${this.times_select}_${this.years_select}.xlsx`
      );
    }
  }
};
</script>

<style scoped>
/* CSS สำหรับจัดการการแสดงผลตารางและส่วนต่างๆ */
.cursor-pointer {
  cursor: pointer;
}
.bg-light-blue {
  background-color: #e1f5fe !important;
}
.bg-white {
  background-color: #ffffff !important;
}
.table-striped ::v-deep tbody tr:nth-of-type(even) {
  background-color: #fafafa;
}
::v-deep .v-data-table tbody tr:hover {
  background-color: #f5f5f5 !important;
}
</style>
